import { render, staticRenderFns } from "./IntegrationSportComp.vue?vue&type=template&id=0df0538c&scoped=true"
import script from "./IntegrationSportComp.vue?vue&type=script&lang=js"
export * from "./IntegrationSportComp.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSportComp.vue?vue&type=style&index=0&id=0df0538c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df0538c",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationSportComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports